import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import axios from "axios";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";

const WellmessVitals = ({
  patientId,
  appointmentId,
  handleClose,
  patientDetails,
}) => {
  console.log(
    patientId,
    appointmentId,
    patientDetails,
    "patientId, appointmentId"
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const onSubmit = (data) => {
    const formattedData = formatData(data);
    sendData(formattedData, patientId, appointmentId);
  };
  const formatData = (data) => {
    return [
      {
        name: "Temperature",
        type: "VitalSigns",
        codeDisplay: "Body surface temperature",
        value: data.temperature,
        sign: "F",
        added: true,
        categoryDisplay: "Vital Signs",
        unit: "degree Fahrenheit",
        unitCode: "[degF]",
        lowerLimit: null,
        id: "body-temperature",
        upperLimit: null,
      },
      {
        name: "Pulse",
        type: "VitalSigns",
        value: data.pulse,
        codeDisplay: "Heart rate",
        sign: "bpm",
        added: true,
        categoryDisplay: "Vital Signs",
        unit: "beats/minute",
        unitCode: "/min",
        lowerLimit: null,
        id: "heart-rate",
        upperLimit: null,
      },
      {
        name: "Respiratory Rate",
        type: "VitalSigns",
        codeDisplay: "Respiratory rate",
        value: data.respiratoryRate,
        sign: "rpm",
        added: true,
        categoryDisplay: "Vital Signs",
        unit: "breaths/minute",
        unitCode: "/min",
        lowerLimit: null,
        id: "respiratory-rate",
        upperLimit: null,
      },
      {
        name: "BP",
        type: "VitalSigns",
        codeDisplay: "Blood pressure panel with all children optional",
        value: data.bloodPressure,
        sign: "mmHg",
        added: true,
        categoryDisplay: "Vital Signs",
        unit: "mmHg",
        unitCode: "mmHg",
        lowerLimit: "120/80",
        id: "blood-pressure",
        upperLimit: "140/90",
      },
      {
        name: "SPO2",
        type: "VitalSigns",
        codeDisplay: "Oxygen saturation in Arterial blood",
        value: data.spo2,
        sign: "%",
        added: true,
        categoryDisplay: "Vital Signs",
        unit: "%",
        unitCode: "%",
        lowerLimit: "90",
        id: "oxygen-saturation",
        upperLimit: "99",
      },
      {
        name: "Height",
        type: "BodyMeasurement",
        codeDisplay: "Body height",
        value: data.height,
        sign: "cm",
        added: true,
        categoryDisplay: "Vital Signs",
        unit: "cm",
        unitCode: "cm",
        lowerLimit: null,
        id: "body-height",
        upperLimit: null,
      },
      {
        name: "Weight",
        type: "BodyMeasurement",
        codeDisplay: "Body weight",
        value: data.weight,
        sign: "kg",
        added: true,
        categoryDisplay: "Vital Signs",
        unit: "kg",
        unitCode: "kg",
        lowerLimit: null,
        id: "body-weight",
        upperLimit: null,
      },
    ];
  };

  const sendData = (formattedData, patientId, appointmentId) => {
    console.log(
      formattedData,
      patientId,
      appointmentId,
      "formattedData, patientId, appointmentId"
    );
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}save_wellness_records/`,
        {
          // wellness_data: formattedData,
          // patient_id: "PAT_109",appointment_id:"appointment-test"
          wellness_data: formattedData,
          patient_id: patientId,
          appointment_id: appointmentId,
        },
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log("Success:", response.data);
        if (response.data?.message === "Successfully uploaded !!") {
          toast.success(
            `${patientDetails.name}’s Vitals/Wellness has been successfully captured`
          );
          handleClose();
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        console.error("Error:", error.response.data);
      });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "15px",
        padding: "10px",
      }}
    >
      <div
        className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style={{ margin: "auto" }}
      >
        {/* <div className="contact-panel mb-50" style={{ position: "relative" }}> */}
        {/* <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 10,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              padding: "8px",
            }}
          >
            <CloseIcon />
          </IconButton>
          {/* <h1
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "clamp(1.5rem, 4vw, 2rem)",
              paddingTop: "10px",
            }}
          >
            Add New Vitals/Wellness
          </h1> */}
        <form className="contact-panel__form" onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="temperature" className="required-label">
                  Temperature (Fahrenheit){" "}
                </label>
                <input
                  type="number"
                  step="0.01"
                  onWheel={(e) => e.target.blur()} // Prevent scroll wheel
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault(); // Prevent arrow keys
                    }
                  }}
                  {...register("temperature", {
                    required: "Temperature is required",
                    valueAsNumber: true,
                    min: {
                      value: 90,
                      message:
                        "Temperature must be greater than or equal to 90°F",
                    },
                    max: {
                      value: 110,
                      message:
                        "Temperature must be less than or equal to 110°F",
                    },
                  })}
                  className="form-control"
                  placeholder="Temperature"
                  style={{ fontSize: "16px" }}
                />
                {errors.temperature && (
                  <p
                    className="errorMsg"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.temperature.message}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="pulse" className="required-label">
                  Pulse (beats/minute){" "}
                </label>
                <input
                  type="number"
                  step="0.01"
                  onWheel={(e) => e.target.blur()} // Prevent scroll wheel
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault(); // Prevent arrow keys
                    }
                  }}
                  {...register("pulse", {
                    required: "Pulse is required",
                    valueAsNumber: true,
                    min: {
                      value: 0,
                      message: "Pulse must be greater than or equal to 0",
                    },
                    max: {
                      value: 250,
                      message: "Pulse must be less than or equal to 250",
                    },
                  })}
                  className="form-control"
                  placeholder="Pulse"
                  style={{ fontSize: "16px" }}
                />
                {errors.pulse && (
                  <p
                    className="errorMsg"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.pulse.message}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="respiratoryRate" className="required-label">
                  Respiratory Rate (breaths/minute){" "}
                </label>
                <input
                  type="number"
                  step="0.01"
                  onWheel={(e) => e.target.blur()} // Prevent scroll wheel
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault(); // Prevent arrow keys
                    }
                  }}
                  {...register("respiratoryRate", {
                    required: "Respiratory Rate is required",
                    valueAsNumber: true,
                    min: {
                      value: 0,
                      message:
                        "Respiratory Rate must be greater than or equal to 0",
                    },
                    max: {
                      value: 70,
                      message:
                        "Respiratory Rate must be less than or equal to 70",
                    },
                  })}
                  className="form-control"
                  placeholder="Respiratory Rate"
                  style={{ fontSize: "16px" }}
                />
                {errors.respiratoryRate && (
                  <p
                    className="errorMsg"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.respiratoryRate.message}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="bloodPressure" className="required-label">
                  Blood Pressure (mmHg){" "}
                </label>
                <InputMask
                  mask="999/999"
                  maskChar=""
                  {...register("bloodPressure", {
                    required: "Blood Pressure is required",
                    pattern: {
                      value: /^[0-9]{1,3}\/[0-9]{1,3}$/,
                      message: "Blood Pressure must be in the format xxx/xxx",
                    },
                    validate: (value) => {
                      const [systolic, diastolic] = value
                        .split("/")
                        .map(Number);
                      if (
                        isNaN(systolic) ||
                        isNaN(diastolic) ||
                        systolic < 0 ||
                        systolic > 300 ||
                        diastolic < 0 ||
                        diastolic > 300
                      ) {
                        return "Each value must be between 0 and 300";
                      }
                      return true;
                    },
                  })}
                  className="form-control"
                  placeholder="Blood Pressure"
                  style={{ fontSize: "16px" }}
                />

                {errors.bloodPressure && (
                  <p
                    className="errorMsg"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.bloodPressure.message}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="spo2" className="required-label">
                  SPO2 (%){" "}
                </label>
                <input
                  type="number"
                  step="0.01"
                  onWheel={(e) => e.target.blur()} // Prevent scroll wheel
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault(); // Prevent arrow keys
                    }
                  }}
                  {...register("spo2", {
                    required: "SPO2 is required",
                    valueAsNumber: true,
                    min: {
                      value: 0,
                      message: "SPO2 must be greater than or equal to 0",
                    },
                    max: {
                      value: 100,
                      message: "SPO2 must be less than or equal to 100",
                    },
                  })}
                  className="form-control"
                  placeholder="SPO2"
                  style={{ fontSize: "16px" }}
                />
                {errors.spo2 && (
                  <p
                    className="errorMsg"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.spo2.message}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="height" className="required-label">
                  Height (cm){" "}
                </label>
                <input
                  type="number"
                  step="0.01"
                  onWheel={(e) => e.target.blur()} // Prevent scroll wheel
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault(); // Prevent arrow keys
                    }
                  }}
                  {...register("height", {
                    required: "Height is required",
                    valueAsNumber: true,
                    min: {
                      value: 20,
                      message: "Height must be greater than or equal to 20",
                    },
                    max: {
                      value: 220,
                      message: "Height must be less than or equal to 220",
                    },
                  })}
                  className="form-control"
                  placeholder="Height"
                  style={{ fontSize: "16px" }}
                />
                {errors.height && (
                  <p
                    className="errorMsg"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.height.message}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="form-group">
                <label htmlFor="weight" className="required-label">
                  Weight (kg){" "}
                </label>
                <input
                  type="number"
                  step="0.01"
                  onWheel={(e) => e.target.blur()} // Prevent scroll wheel
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault(); // Prevent arrow keys
                    }
                  }}
                  {...register("weight", {
                    required: "Weight is required",
                    valueAsNumber: true,
                    min: {
                      value: 1,
                      message: "Weight must be greater than or equal to 1",
                    },
                    max: {
                      value: 300,
                      message: "Weight must be less than or equal to 300",
                    },
                  })}
                  className="form-control"
                  placeholder="Weight"
                  style={{ fontSize: "16px" }}
                />
                {errors.weight && (
                  <p
                    className="errorMsg"
                    style={{ color: "red", fontSize: "14px" }}
                  >
                    {errors.weight.message}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <button
                type="submit"
                className="btn btn__secondary btn__rounded btn__block mt-6"
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  margin: "20px auto",
                  display: "block",
                  padding: "12px 24px",
                  fontSize: "16px",
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    // </div>
  );
};

export default WellmessVitals;
